import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminUsersPage = lazy(() => import("@/pages/admin.users.page"));

export const Route = createFileRoute("/admin/users")({
  component: AdminUsersPage,
});
